<script setup lang="ts"></script>

<template>
  <div
    class="min-h-screen bg-base-200 text-base-content flex items-center justify-center p-0 sm:p-4"
  >
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="px-4 py-6 sm:px-5 sm:py-7">
        <router-view />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
